module.exports = __webpack_public_path__ + "static/img/jrsi.b302026.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jrsi.jpg
// module id = sQKf
// module chunks = 0